/* eslint-disable standard/no-callback-literal */
import axios from "axios";

// eslint-disable-next-line no-unused-vars
var callback;

var http = axios.create({
    baseURL: process.env.API_BASE_URL,
    headers: { "Content-Type": "application/json" },
});

http.interceptors.response.use(
    function (response) {
        return response;
    },

    function (error) {
        if (error.response.status !== 401) return Promise.reject(error);

        var refreshAndRetry = new Promise(function (resolve) {
            axios
                .post(
                    process.env.API_BASE_URL + "account/refresh_token",
                    {
                        // eslint-disable-next-line no-undef
                        refresh_token: JSON.parse(
                            localStorage.getItem("refresh_token"),
                        ).value,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            // eslint-disable-next-line no-undef
                            Authorization:
                                "Bearer " +
                                JSON.parse(localStorage.getItem("token")).value,
                        },
                    },
                )
                .then(function (response) {
                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "refresh_token",
                        JSON.stringify({
                            value: response.data.refresh_token,
                            expire: null,
                        }),
                    );

                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "token",
                        JSON.stringify({
                            value: response.data.token,
                            expire: null,
                        }),
                    );

                    return Promise.resolve(response);
                })
                .then(function (response) {
                    var failedRequest = error.config;
                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                });
        });

        return refreshAndRetry;
    },
);

function getConfig() {
    return {
        headers: {
            // eslint-disable-next-line no-undef
            Authorization: JSON.parse(localStorage.getItem("token")).value,
        },
    };
}

function createLiveClass(data, callback) {
    var config = getConfig();
    var postData = {
        name: data.name,
        description: data.description,
        subject: data.subject,
        teachers: data.teachers,
        teacherDetails: data.teacherDetails,
        roomUrl: data.roomUrl,
        youtubeUrl: data.youtubeUrl,
        meetingId: data.meetingId,
        roomPassword: data.roomPassword,
        level: data.level,
        type: data.type,
        groupId: data.groupId,
        grade: data.grade,
        isPrivate: data.isPrivate,
        code: data.code,
        thumbnail: data.thumbnail,
        // quota: data.quota,
        startAt: data.startAt,
        endAt: data.endAt,
        youtubeUrl: data.youtubeUrl,
        user_group: data.user_group,
        is_special: data.is_special,
        user_type: data.user_type,
        material_description: data.material_description,
        program_benefit: data.program_benefit,
    };

    http.post("liveclass/savedata", postData, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
                status: response.status,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editLiveClass(data, callback) {
    var config = getConfig();
    var postData = {
        id: data.id,
        name: data.name,
        description: data.description,
        subject: data.subject,
        teachers: data.teachers,
        teacherDetails: data.teacherDetails,
        roomUrl: data.roomUrl,
        youtubeUrl: data.youtubeUrl,
        meetingId: data.meetingId,
        roomPassword: data.roomPassword,
        level: data.level,
        type: data.type,
        groupId: data.groupId,
        grade: data.grade,
        isPrivate: data.isPrivate,
        code: data.code,
        thumbnail: data.thumbnail,
        record_video_url: data.record_video_url,
        record_video_duration: data.record_video_duration,
        // quota: data.quota,
        startAt: data.startAt,
        endAt: data.endAt,
        youtubeUrl: data.youtubeUrl,
        user_group: data.user_group,
        presentationPath: data.presentationPath,
        is_special: data.is_special,
        user_type: data.user_type,
        material_description: data.material_description,
        program_benefit: data.program_benefit,
    };

    http.put("liveclass/admin/" + data.id + "/editdata", postData, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListOfliveClasses(callback) {
    var config = getConfig();
    http.get("liveclass/admin/getlistclasses", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListOfliveClassesPaging(params, callback) {
    var config = getConfig();
    // alert(JSON.stringify(params));
    http.get(
        `liveclass/admin/getlistclassespage?page=${params.page}&per_page=${params.per_page}&name=${params.name}&description=${params.description}&sort=${params.sort}&subject=${params.subject}&jenjang=${params.jenjang}&grades=${params.grades}`,
        config,
    )
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getTeachers(callback) {
    var config = getConfig();
    http.get("liveclass/teachers", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListMembers(id, params, callback) {
    var config = getConfig();
    http.get(
        `liveclass/getlistclass/${id}/memberdetails?name=${params.search}&page=${params.page}&size=${params.size}`,
        config,
    )
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deleteLiveClass(id, callback) {
    var config = getConfig();
    http.get("liveclass/deleteclass/" + id, config)
        .then(function (response) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            // eslint-disable-next-line standard/no-callback-literal
            callback({
                success: false,
                message: error.message,
            });
        });
}

export default {
    createLiveClass,
    editLiveClass,
    deleteLiveClass,
    getListOfliveClasses,
    getTeachers,
    getListMembers,
    getListOfliveClassesPaging,
};



// WEBPACK FOOTER //
// ./src/modules/live_class/services/liveclass.js